import {LocationValueObject} from './LocationValueObjectLegacy.js'

export class LocationValueObjectsFactory {
  /**
   * @return {LocationValueObject}
   */
  static locationValueObject = ({
    address,
    city,
    province,
    provinceId,
    provinceIds,
    postalCode,
    coordinates,
    mapsDirectionsUrl
  }) => {
    return new LocationValueObject({
      address,
      city,
      province,
      provinceId,
      provinceIds,
      postalCode,
      coordinates,
      mapsDirectionsUrl
    })
  }
}
